var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page page-on-center close-picker",
      attrs: { id: "inbox", "data-page": "inbox-page" },
      on: {
        "ptr:refresh": function ($event) {
          return _vm.refreshUBODetails(false)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "page-content infinite-scroll",
          staticStyle: { "z-index": "9" },
        },
        [
          _c("div", { staticClass: "layoutTop" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "listPage",
              staticStyle: { "margin-left": "5%", width: "90%" },
            },
            [
              _c("back-button"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "pilotageTabButtonContainer pilotageTabButtonContainerRegister",
                },
                [
                  _c(
                    "f7-grid",
                    [
                      _c(
                        "f7-col",
                        { staticClass: "pilotageTabController" },
                        [
                          _c(
                            "f7-link",
                            {
                              staticClass:
                                "pilotageLink upperLeftRadius upperRightRadius tabActive",
                              attrs: { "tab-link": ".documentsTab" },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\r\n                Client : " +
                                    _vm._s(_vm.currentSupplier.SocialReason) +
                                    " - Identifiant : " +
                                    _vm._s(_vm.currentSupplier.Siren) +
                                    "\r\n              "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _c(
                    "f7-tabs",
                    [
                      _c(
                        "f7-tab",
                        {
                          staticClass: "documentsTab",
                          attrs: { "no-gutter": "", active: "" },
                        },
                        [
                          _vm.activateSpinner
                            ? _c("spinner")
                            : _c(
                                "b-container",
                                { attrs: { fluid: "" } },
                                [
                                  _c(
                                    "b-row",
                                    _vm._l(
                                      _vm.documentsList,
                                      function (document) {
                                        return document.Type !==
                                          "PROOF_OF_ADDRESS"
                                          ? _c(
                                              "b-col",
                                              {
                                                key: document.IdDocument,
                                                staticClass: "documentBlocInfo",
                                                attrs: { sm: "3" },
                                              },
                                              [
                                                _c("document-bloc-info", {
                                                  attrs: {
                                                    document: document,
                                                    seller: _vm.currentSupplier,
                                                    shareholder: false,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-start" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          attrs: { md: "3", "offset-md": "9" },
                                        },
                                        [
                                          _vm.currentSupplier.Status !== "31"
                                            ? _c(
                                                "f7-button",
                                                {
                                                  staticClass:
                                                    "button-action milkyBlockBlack",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateFolderStatus(
                                                        "31"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("f7-icon", {
                                                    attrs: { fa: "check" },
                                                  }),
                                                  _vm._v(
                                                    "\r\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "suppliers.close_doc_group"
                                                        )
                                                      ) +
                                                      "\r\n                "
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.currentSupplier.Status === "31"
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                    "margin-top": "20px",
                                                    "font-size": "20px",
                                                    color: "green",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                  Compte Client Vérifié\r\n                  "
                                                  ),
                                                  _c("f7-icon", {
                                                    staticClass: "greenIcon",
                                                    attrs: { fa: "check" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }